/** @format */

// Func = limiting Scope for this file
var lastScrollTop = 0;

//datepicker booking main
var opened = 0;
var start = $("#arriveInput").attr("value");
var end = $("#departureInput").attr("value");
var opencheck = 0;
var firstClick = 0;


(function () {

  //homepage dropdown
  if (document.getElementById("rooms_home")) {
    let HOME_DROP = document.getElementById("rooms_home");
    let HOME_DROP_TEXT = document.getElementById("homeDropText");
    HOME_DROP.addEventListener("change", function () {
      let NEW_VALUE = this.options[this.selectedIndex].text;
      HOME_DROP_TEXT.innerHTML = NEW_VALUE;
    });
  }

  let SITEURL = window.location.href;
  if (SITEURL.indexOf("#") > 0) {
    let strAncla = SITEURL.split("#");
    animateto(strAncla[1]);
  }

  if (!window.ActiveXObject && "ActiveXObject" in window) {
    //is explorer
    function msieversion() {
      var ua = window.navigator.userAgent;
      var msie = ua.indexOf("MSIE ");
      if (msie > 0 || !!navigator.userAgent.match(/Trident.*rv\:11\./)) {
        const image_fit = document.getElementsByClassName("image-fit__wrapper");
        for (let i = 0; i < image_fit.length; i++) {
          const this_image = image_fit[i].getElementsByTagName("img")[0];
          const image_data = this_image.dataset.srcset;
          const image_src = this_image.getAttribute("src");
          image_fit[i].classList.add("ie-bg");
          if (image_data) {
            image_fit[i].style.backgroundImage = 'url("' + image_data + '")';
          } else {
            image_fit[i].style.backgroundImage = 'url("' + image_src + '")';
          }
        }
      } else {
        console.log("other browser");
      }

      return false;
    }

    msieversion();
  } else {
    /*****************************************************
		 OBSERVER TO ADD PARALLAX EFFECT
		 /*****************************************************/
    var scrollParallax = [];
    var scrolled = 0;

    // screen height
    var v_height =
      window.innerHeight ||
      document.documentElement.clientHeight ||
      document.body.clientHeight;

    function doParallax(elm) {
      let boundes = elm.dataset.parallax.split(","); // get it from html
      //get distance in positive value
      let distance = Math.abs(boundes[0] - boundes[1]);
      if (boundes[0] > boundes[1]) {
        //get distance in negative value (to do the scroll inverse)
        distance = distance * -1;
      }
      //Equivalent distance using screen height + element height
      const unit_scroll = distance / (v_height + elm.offsetHeight);
      let temp = 0;

      let topElement = 0;
      let element = elm;

      let id_elem = elm.dataset.parallaxid;

      do {
        topElement += element.offsetTop || 0;
        element = element.offsetParent;
      } while (element);

      let parallaxFunction = function () {
        //Obtain the distance between top screen and document top 0
        scrolled = document.documentElement.scrollTop || window.pageYOffset;
        //Distance of bottom page to top of the element
        let relative_distance = scrolled + v_height - topElement;
        //transpoling data to move the parallax element relative to the scroll of all the screen
        temp = unit_scroll * relative_distance + parseInt(boundes[0]);
        //console.log('scroll: '+scrolled+' v_height: '+v_height+' element top: '+elm.offsetTop)
        elm.setAttribute("style", "transform: translate(0, " + temp + "px)");
      };

      scrollParallax[id_elem] = parallaxFunction;

      window.addEventListener("scroll", scrollParallax[id_elem]);
    }

    let observers_parallax = document.querySelectorAll(".js-parallax-element");

    if (observers_parallax) {
      let options_parallax = {
        root: null, // relative to document viewport
        rootMargin: "0px", // margin around root. Values are similar to css property. Unitless values not allowed
        threshold: 0, // visible amount of item shown in relation to root
      };

      function handler_parallax(entries, observer) {
        let entry;
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            doParallax(entry.target);
          } else {
            let id_elem = entry.target.dataset.parallaxid;
            window.removeEventListener("scroll", scrollParallax[id_elem]);
          }
        });
      }

      let observable_parallax = new IntersectionObserver(
        handler_parallax,
        options_parallax
      );
      let counter = 1;
      observers_parallax.forEach(function (element) {
        observable_parallax.observe(element);
        element.dataset.parallaxid = counter;
        counter++;
      });
    }
    /********************************************************************************
		 END OF OBSERVER TO ADD PARALLAX EFFECT
		 ***********************************************************************************/
  }

  $(".form-module-wrapper form").addClass("animate-fade top");
  $(".text-modules-wrapper .text-modules").addClass("animate-fade top");

  let Body = document.body;
  let BtnBook = document.getElementById("js_btn_book");
  let BookingBox = document.getElementById("bookBox");
  let BookClose = document.getElementById("js_book_close");

  if (BtnBook) {
    BtnBook.addEventListener("click", function (e) {
      e.preventDefault();
      BookingBox.classList.add("open");
      Body.classList.add("scroll-no");
    });
  }

  if (BookClose) {
    BookClose.addEventListener("click", function (e) {
      e.preventDefault();
      BookingBox.classList.remove("open");
      Body.classList.remove("scroll-no");
    });
  }

  $(document).ready(function () {
    // Main Nav Dropdown
    $("#primary-nav li").hover(
      function () {
        $("ul.submenu", this).fadeIn(200);
      },
      function () {
        $("ul.submenu", this).fadeOut(200);
      }
    );

    $("a[href^='#']:not(:where(a[data-fancybox], a[data-filter], a.accordion-toggle, a#js_btn_book))"
    ).click(function (e) {
      e.preventDefault();
      let strAncla = $(this).prop("hash").substr(1);

      if ($(this).hasClass("to_link")) {
        if (!$("body").hasClass("villas-scottsdale-az")) {
          open(site_url + "villas-scottsdale-az#" + strAncla, "_self");
        } else {
          animateto(strAncla);

          $(".navigation").removeClass("open");
          $(".navigation")
            .stop()
            .animate({ left: "100%" }, { queue: false, duration: 300 });
        }
      } else {
        animateto(strAncla);

        $(".navigation").removeClass("open");
        $(".navigation")
          .stop()
          .animate({ left: "100%" }, { queue: false, duration: 300 });
      }
    });

    menuLinksInteraction();

    function menuLinksInteraction() {
      if (document.getElementsByClassName("menu-images").length > 0) {
        //ini
        let ini = 0;
        let allPrimaryA = document
          .getElementById("primary-nav")
          .getElementsByTagName("li");
        let allGalleryI = document.getElementsByClassName("menu-images");
        let allPrimaryB = document
          .getElementById("primary-nav")
          .getElementsByTagName("a");

        let indexLi = 0;
        for (let i = 0; i < allPrimaryA.length; i++) {
          if (!allPrimaryA[i].parentElement.classList.contains("submenu")) {
            indexLi++;
          }
          if (allPrimaryA[i].children[1]) {
            allPrimaryA[i].classList.add("sub-active");
          }
          allPrimaryA[i].setAttribute("data-li", indexLi);
          if (allPrimaryB[i].classList.contains("active")) {
            for (let j = 0; j < allGalleryI.length; j++) {
              if (
                allPrimaryA[i].getAttribute("data-li") ==
                allGalleryI[j].getAttribute("data-img")
              ) {
                allGalleryI[j].classList.add("active");
                ini = 1;
              }
            }
          }
        }

        if (ini == 0) {
          allGalleryI[0].classList.add("active");
        }

        //hover
        let indexImg = 0;
        for (let i = 0; i < allPrimaryA.length; i++) {
          if (!allPrimaryA[i].parentElement.classList.contains("submenu")) {
            indexImg++;
          }
          allPrimaryA[i].setAttribute("data-image", indexImg);
        }
        for (let i = 0; i < allPrimaryA.length; i++) {
          allPrimaryA[i].addEventListener("mouseenter", function (e) {
            for (let j = 0; j < allGalleryI.length; j++) {
              allGalleryI[j].classList.remove("active");
              if (
                this.getAttribute("data-image") ==
                allGalleryI[j].getAttribute("data-img")
              ) {
                allGalleryI[j].classList.add("active");
              }
            }
          });
        }
      }
    }

    let subActive = document.getElementsByClassName("sub-active");
    let navigationInfo = document.getElementById("primary-nav");
    let galleryNav = document.getElementById("gallery_nav");
    let BgMenu = document.getElementById("bg_menu");
    if (subActive) {
      for (let i = 0; i < subActive.length; i++) {
        subActive[i].addEventListener("mouseover", function () {
          navigationInfo.classList.add("open-info");
          galleryNav.classList.add("open-gallery");
          BgMenu.classList.add("active");
        });

        subActive[i].addEventListener("mouseout", function () {
          navigationInfo.classList.remove("open-info");
          galleryNav.classList.remove("open-gallery");
          BgMenu.classList.remove("active");
        });
      }
    }

    //To create after event
    $.datepicker._updateDatepicker_original = $.datepicker._updateDatepicker;
    $.datepicker._updateDatepicker = function (inst) {
      $.datepicker._updateDatepicker_original(inst);
      var afterShow = this._get(inst, "afterShow");
      if (afterShow) afterShow.apply(inst.input ? inst.input[0] : null); // trigger custom callback
    };


    //HOME datepicker
    $('#arriveInputHome').datepicker({
      changeMonth: false,
      dateFormat: "mm/dd/yy",
      numberOfMonths: 1,
      onSelect: function( selectedDate ) {
				let getDate = $(this).datepicker('getDate');
				let newDate = new Date(getDate.getTime());
				newDate.setDate(newDate.getDate() + 3);
				$( "#departureInputHome" ).datepicker( "setDate", newDate );
				$( "#departureInputHome" ).datepicker( "option", "minDate", selectedDate );
        
        let separateIn = $('#arriveInputHome').val().split('/');
        let separateOut = $('#departureInputHome').val().split('/');
        $('#homeAltIn').attr('value',separateIn[1] + '/' + separateIn[0] + '/' + separateIn[2]);
        $('#homeAltOut').attr('value',separateOut[1] + '/' + separateOut[0] + '/' + separateOut[2]);


        $('#arriveInput').attr('value',$('#arriveInputHome').val());
        $('#departureInput').attr('value',$('#departureInputHome').val());
        $('#altIn').attr('value',separateIn[1] + '/' + separateIn[0] + '/' + separateIn[2]);
        $('#altOut').attr('value',separateOut[1] + '/' + separateOut[0] + '/' + separateOut[2]);

        start = $('#arriveInputHome').val();
        end = $('#departureInputHome').val();

        $('.calendar-block').datepicker("setDate", start);

			}
    });
    $('#departureInputHome').datepicker({
      changeMonth: false,
      dateFormat: "mm/dd/yy",
      numberOfMonths: 1,
      onSelect: function( selectedDate ) {
        
        
        let separateOut = $('#departureInputHome').val().split('/');
        $('#homeAltOut').attr('value',separateOut[1] + '/' + separateOut[0] + '/' + separateOut[2]);

       
        $('#departureInput').attr('value',$('#departureInputHome').val());
        $('#altOut').attr('value',separateOut[1] + '/' + separateOut[0] + '/' + separateOut[2]);

        end = $('#departureInputHome').val();

        $('.calendar-block').datepicker("setDate", end);

			}
    });



    $(".calendar-block").datepicker({
      changeMonth: false,
      dateFormat: "mm/dd/yy",
      numberOfMonths: 2,
      beforeShowDay: function (date) {
        setTimeout(function() {
          document.querySelectorAll('.ui-datepicker-calendar td a').forEach(e => {
            e.setAttribute('tabindex', '-1');
          })
        }, 1000);
        $.datepicker._defaults.dateFormat = "mm/dd/yy";
        var startDate = $.datepicker.parseDate(
          $.datepicker._defaults.dateFormat,
          start
        );
        var endDate = $.datepicker.parseDate(
          $.datepicker._defaults.dateFormat,
          end
        );
        if (date.getTime() == startDate.getTime()) {
          return [true, "startday"];
        } else {
          if (date.getTime() == endDate.getTime()) {
            return [true, "endday"];
          } else {
            if (
              date.getTime() > startDate.getTime() &&
              date.getTime() < endDate.getTime()
            ) {
              return [true, "days"];
            } else {
              return [true, ""];
            }
          }
        }
      },
      onSelect: function (date) {
        let arrive = $.datepicker.parseDate(
          $.datepicker._defaults.dateFormat,
          start
        );
        let departure = $.datepicker.parseDate(
          $.datepicker._defaults.dateFormat,
          end
        );
        let selectedDate = $.datepicker.parseDate(
          $.datepicker._defaults.dateFormat,
          date
        );

        if (opened == 0) {
          opened = 1;
          start = date;
          end = date;
          opencheck = 0;
        } else {
          opened = 0;
          if (selectedDate <= arrive) {
            end = start;
            start = date;
          } else {
            end = date;
          }
          $("#fakeInput").fadeOut();
          opencheck = 1;
          firstClick = 0;
        }
        

        let separateIn = start.split('/');
        let separateOut = end.split('/');

        $('#arriveInput').attr('value',start);
        $('#departureInput').attr('value',end);

        $('#arriveInputHome').attr('value',start);
        $('#departureInputHome').attr('value',end);

        $('#homeAltIn').attr('value',separateIn[1] + '/' + separateIn[0] + '/' + separateIn[2]);
        $('#homeAltOut').attr('value',separateOut[1] + '/' + separateOut[0] + '/' + separateOut[2]);
        $('#altIn').attr('value',separateIn[1] + '/' + separateIn[0] + '/' + separateIn[2]);
        $('#altOut').attr('value',separateOut[1] + '/' + separateOut[0] + '/' + separateOut[2]);

      
      },
      onChangeMonthYear: function () {
        opencheck = 1;
      },
    });

    

   

    function addDay(initDate, days) {
      initDate.setDate(initDate.getDate() + days);
      return initDate;
    }

    $("input[name=zip_code]").attr("maxlength", "5");

    $(".special-slider-book").slick({
      arrows: true,
      dots: false,
      infinite: true,
      autoplay: true,
      autoplaySpeed: 3000,
      speed: 500,
      vertical: true,
      verticalSwiping: true,
      slidesToShow: 2,
      slidesToScroll: 1,
      accessibility: true,
      responsive: [
        {
          breakpoint: 800,
          settings: {
            vertical: false,
            verticalSwiping: false,
          },
        },
      ],
    });

    $(
      ".overlap-bg-block .overlap-content .items .item a.btn-item .title, .overlap-block .overlap-info .items-overlap .item .title"
    ).each(function () {
      let htmlString = $(this).text();
      $(this).html(
        '<span class="text-one">' +
          htmlString +
          '</span><span class="text-two">' +
          htmlString +
          "</span>"
      );
    });
  });

  window.onload = function () {
    scrollW();
    window.addEventListener("scroll", function () {
      scrollW();
    });
  };
})();

function scrollW() {
  //check scroll down or up for header styles
  let st = window.pageYOffset || document.documentElement.scrollTop;
  if (st > 80) {
    if (st > lastScrollTop) {
      // downscroll code
      if (!document.getElementById("header").classList.contains("down")) {
        document.getElementById("header").classList.add("down");
        document.getElementById("header").classList.remove("up");
      }
    } else {
      // upscroll code
      if (!document.getElementById("header").classList.contains("up")) {
        document.getElementById("header").classList.add("up");
        document.getElementById("header").classList.remove("down");
      }
    }
  } else {
    if (
      document.getElementById("header").classList.contains("up") ||
      document.getElementById("header").classList.contains("down")
    ) {
      document.getElementById("header").classList.remove("up");
      document.getElementById("header").classList.remove("down");
    }
  }

  let SubMenu = document.getElementById("subMenuAnchor");
  if (SubMenu) {
    let subPost = document.getElementById("subMenu");
    let subPosition = "";
    if (document.body.classList.contains("alert_open")) {
      subPosition = offset(SubMenu).top - 122;
    } else {
      subPosition = offset(SubMenu).top - 78;
    }
    if (st > subPosition) {
      if (!subPost.classList.contains("floating-up")) {
        subPost.classList.add("floating-up");
      }
    } else {
      if (subPost.classList.contains("floating-up")) {
        subPost.classList.remove("floating-up");
      }
    }
  }
  lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling
}
